module.exports = __webpack_public_path__ + "static/media/a42.6acfb23a.jpg";